import React, { useEffect } from "react";
import NavBar from "../Navigation/NavBar";
import Footer from "../Footer/Footer";
import Contant from "./Contant";

function PermanentStaffing() {
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); }, []);
  return <><NavBar /><Contant PageName="PERMANENT STAFFING SOLUTIONS" /><Footer /></>;
}
export default PermanentStaffing;
